const mapStateToProps = state => 
     ({
        correoUsuario: state.signUp.correoUsuario
    });

export default mapStateToProps;
